
import Component from './component';

export interface Props {
   title?: string;
   subtitle?: string;
   background?: string;
   backgroundAlt?:string;
}

Component.defaultProps = {};

export default Component;